import React from 'react';
export function TomoCards() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const tomos = [{
    color: 'text-[#52B788]',
    title: 'Problemáticas Ambientales Rurales',
    emoji: '🌱'
  }, {
    color: 'text-[#40916C]',
    title: 'Producción Sustentable',
    emoji: '🌿'
  }, {
    color: 'text-[#2D6A4F]',
    title: 'Proyectos Ambientales',
    emoji: '🌾'
  }, {
    color: 'text-[#1B9AAA]',
    title: 'Educación Ambiental Aplicada',
    emoji: '🌎'
  }, {
    color: 'text-[#6B8E23]',
    title: 'Actividades y Trabajo de Campo',
    emoji: '🧭'
  }, {
    color: 'text-[#D4A843]',
    title: 'Planificación y Evaluación',
    emoji: '📊'
  }];
  return <section className="bg-[#071A14] py-3 px-2 border-b border-[#1F3D2B]" data-id="element-218">
      <div className="max-w-4xl mx-auto" data-id="element-219">
        <div className="flex gap-1.5 overflow-x-auto pb-1 scrollbar-hide justify-start md:justify-center" data-id="element-220">
          {tomos.map((tomo, i) => <div key={i} onClick={scrollToPricing} className="bg-[#102A1F] border border-[#1F3D2B] rounded-xl p-1.5 text-center cursor-pointer transform hover:-translate-y-0.5 hover:border-[#D4A843] hover:glow-gold transition-all duration-200 shadow-sm flex-shrink-0 w-[75px] md:w-24 flex flex-col justify-center items-center" data-id="element-221">
              <div className="text-lg md:text-xl mb-0.5 leading-none" data-id="element-222">
                {tomo.emoji}
              </div>
              <h4 className={`font-black text-[8px] md:text-[9px] leading-tight uppercase ${tomo.color}`} data-id="element-223">
                {tomo.title}
              </h4>
            </div>)}
        </div>
      </div>
    </section>;
}